<template>
  <div class="game-view-wrapper">
    <EmbeddedGameWaitingRoom :gameType="activeGameType" />
  </div>
</template>

<script>
import EmbeddedGameWaitingRoom from '@/components/waiting/EmbeddedGameWaitingRoom.vue'

export default {
  name: 'GameView',
  components: {
    EmbeddedGameWaitingRoom
  },
  computed: {
    activeGameType() {
      const q = String(this.$route?.query?.game || '').toLowerCase()
      if (q.includes('billar')) return 'billar'
      return 'bolas'
    }
  },
  mounted() {
    if (!this.$store.getters['auth/isAuthenticated']) {
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.game-view-wrapper {
  min-height: 100vh;
  min-height: 100dvh;
  width: 100%;
}
</style>
